








































































  import { Component } from 'vue-property-decorator'
  import { mixins } from 'nuxt-property-decorator'
  import { Stocks } from '@one/types'
  import { BindingHelpers } from 'vuex-class/lib/bindings'
  import { namespace } from 'vuex-class'
  import CurrentProductMixin from '~/mixins/CurrentProduct'
  import UtilsMixin from '~/mixins/UtilsMixin'
  import { MappedProductStocks } from '~/store/stocks/types'
  import Warehouse = Stocks.Warehouse
  import StockVisibilityMode = Stocks.StockVisibilityMode

  enum warehouseType {
    CENTRAL = 'CENTRAL',
    LOCAL = 'LOCAL',
  }
  const stocks: BindingHelpers = namespace('stocks')
  const products: BindingHelpers = namespace('products')
  const account: BindingHelpers = namespace('account')

  @Component({
    components: {
      OneProductStocksLabel: () =>
        import('~/components/organisms/product/OneProductStocksLabel.vue'),
      OneProductStocksPopupDialog: () =>
        import('~/components/organisms/product/OneProductStocksPopupDialog.vue'),
    },
  })
  export default class OneProductStocks extends mixins(CurrentProductMixin, UtilsMixin) {
    @stocks.Getter getWarehouse: any
    @stocks.Getter getProductStocks: any
    @stocks.Getter getProductWarehouse: any
    @stocks.Getter getProductOrderQuantityInWarehouse: any
    @stocks.Getter isEnoughProductWithBlockLabelInStock: any
    @stocks.Getter getDefaultWarehouseId: any
    @stocks.Getter getDefaultWarehouse: any
    @stocks.Getter getCentralWarehouse: any
    @products.Getter getProductLabels: any
    @products.Getter getProductOrderUnit: any
    @account.Getter warehouseSelectionBlocked: any

    get isProductBlocked(): boolean {
      return this.getProductLabels('Block', this.$product?.id)
    }

    get displayProductTimeInfo(): string | undefined {
      if (this.isProductBlocked && this.orderQuantityInParentWarehouse === 0) {
        return ''
      } else if (!this.isProductBlocked && this.orderQuantityInParentWarehouse === 0) {
        return this.$product?.shippingTime
      } else {
        return this.shippingTime.parentWarehouse
          ? `${this.shippingTime.parentWarehouse} ${this.$t('product_page.hour')}`
          : ''
      }
    }

    get defaultWarehouseDeliveryInfo(): string | undefined {
      if (this.isProductBlocked && this.orderQuantityInSelectedWarehouse === 0) {
        return ''
      } else if (!this.isProductBlocked && this.orderQuantityInSelectedWarehouse === 0) {
        return this.$product?.shippingTime
      } else {
        return this.shippingTime.defaultWarehouse
          ? `${this.shippingTime.defaultWarehouse} ${this.$t('product_page.hour')}`
          : ''
      }
    }

    get isCentralWarehouse(): boolean {
      return (this.currentWarehouse?.type as any) === warehouseType.CENTRAL
    }

    get areStocksAvailable(): boolean {
      return this.stocks !== null
    }

    get stocks(): MappedProductStocks | null {
      return this.getProductStocks(this.$product?.id)
    }

    get orderQuantityInParentWarehouse(): number {
      if (!this.$product) {
        return 0
      }

      return this.isTileCalculator(this.$product)
        ? this.stocks?.warehouses.byId[this.getDefaultWarehouse?.parent]?.quantity
        : this.getProductOrderQuantityInWarehouse(this.$product.id, this.parentWarehouse?.id)
    }

    get availabilityInParentWarehouse(): boolean | undefined {
      if (!this.$product) {
        return false
      }
      return this.isTileCalculator(this.$product)
        ? this.stocks?.warehouses.byId[this.getDefaultWarehouse?.parent]?.available
        : this.parentWarehouse?.id
        ? this.stocks?.warehouses.byId[this.parentWarehouse.id]?.available
        : false
    }

    get stockVisibilityModeHidden(): boolean {
      return this.stocks?.stockVisibilityMode === StockVisibilityMode.HIDDEN
    }

    get orderQuantityInSelectedWarehouse(): number {
      if (!this.$product) {
        return 0
      }

      return this.isTileCalculator(this.$product)
        ? this.stocks?.warehouses.byId[this.getDefaultWarehouseId]?.quantity
        : this.getProductOrderQuantityInWarehouse(this.$product.id, this.getDefaultWarehouseId)
    }

    get availabilityInSelectedWarehouse(): boolean | undefined {
      if (!this.$product) {
        return false
      }
      return this.stocks?.warehouses.byId[this.getDefaultWarehouseId]?.available
    }

    get currentWarehouse(): Warehouse | null {
      return this.getWarehouse(this.getDefaultWarehouseId)
    }

    get parentWarehouse(): Warehouse | null {
      return this.currentWarehouse && this.getWarehouse(this.currentWarehouse.parent)
    }

    get unit() {
      return this.isTileCalculator(this.$product)
        ? this.getProduct(this.$product?.id).measurementUnits.contentUnitDescription
        : this.getProductOrderUnit(this.$product?.id)
    }

    get labels(): any {
      return {
        parentWarehouse: (this.parentWarehouse && this.getLabel(this.parentWarehouse.id)) ?? '-',
        defaultWarehouse: this.getLabel(this.getDefaultWarehouseId),
      }
    }

    get shippingTime(): any {
      return {
        parentWarehouse:
          (this.parentWarehouse && this.getShippingTime(this.parentWarehouse.id)) ?? '-',
        defaultWarehouse: this.getShippingTime(this.getDefaultWarehouseId),
      }
    }

    get warehouses() {
      if (!this.stocks) {
        return []
      }
      return this.stocks.warehouses.allIds
        .map((stockId: string) => ({
          id: stockId,
          unity: this.stocks!.unit,
          quantity: this.getProductOrderQuantityInWarehouse(this.$product?.id, stockId),
          label: this.getLabel(stockId),
          shippingTime: this.getShippingTime(stockId),
          type: this.getWarehouse(stockId).type,
          available: this.getAvailability(stockId),
          stockVisibilityModeHidden: this.stockVisibilityModeHidden,
        }))
        .filter(
          (item: any) =>
            item.id !== this.getDefaultWarehouseId && item.id !== this.parentWarehouse?.id,
        )
        .sort((a: any, b: any): number => {
          if (a.label < b.label) {
            return -1
          }
          if (a.label > b.label) {
            return 1
          }
          return 0
        })
    }

    warehouse(id: string) {
      return this.getProductWarehouse(this.$product?.id, id)
    }

    getLabel(id: string) {
      return this.warehouse(id)?.warehouseLabel ?? '-'
    }

    getAvailability(id: string) {
      return this.warehouse(id)?.available
    }

    getShippingTime(id: string) {
      return this.getWarehouse(id)?.shippingTime
    }
  }
